<template>
    <div class="main">
        <c-panel title="MONITOR DE ACESSOS" titleIcon="fas fa-walking">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Entradas e saídas registradas pelos equipamentos de reconhecimento facial."
                description="A entrada gera presença automática quando há configuração de frequência. Lançamento do professor nunca é sobrescrito — divergência vira conflito para conferência no diário."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Escola" class="u-mb-0">
                            <el-select v-model="instituicaoId" filterable style="width: 100%;" @change="carregar">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="5">
                        <el-form-item label="Data" class="u-mb-0">
                            <el-date-picker v-model="data" type="date" format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width: 100%;" @change="carregar"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="5" class="u-mt-25">
                        <el-checkbox v-model="autoAtualizar" @change="alternarAuto">Atualizar a cada 30s</el-checkbox>
                    </el-col>
                    <el-col :xs="24" :sm="6" class="u-text-right u-mt-25">
                        <el-button size="small" icon="el-icon-refresh" @click="carregar">ATUALIZAR</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <el-row v-if="monitor" :gutter="10" class="u-mb-20">
                <el-col :xs="12" :sm="3"><div class="kpi kpi-entrada"><span class="n">{{ monitor.kpis.entradas }}</span><span class="r">Entradas</span></div></el-col>
                <el-col :xs="12" :sm="3"><div class="kpi kpi-saida"><span class="n">{{ monitor.kpis.saidas }}</span><span class="r">Saídas</span></div></el-col>
                <el-col :xs="12" :sm="3"><div class="kpi"><span class="n">{{ monitor.kpis.alunos_distintos }}</span><span class="r">Alunos</span></div></el-col>
                <el-col :xs="12" :sm="3"><div class="kpi kpi-ok"><span class="n">{{ monitor.kpis.frequencias_geradas }}</span><span class="r">Presenças geradas</span></div></el-col>
                <el-col :xs="12" :sm="4"><div class="kpi kpi-alerta"><span class="n">{{ monitor.kpis.nao_identificados }}</span><span class="r">Não identificados</span></div></el-col>
                <el-col :xs="12" :sm="4"><div class="kpi kpi-erro"><span class="n">{{ monitor.kpis.conflitos }}</span><span class="r">Conflitos no diário</span></div></el-col>
                <el-col :xs="12" :sm="4"><div class="kpi kpi-ok"><span class="n">{{ monitor.kpis.responsaveis_notificados }}</span><span class="r">Responsáveis avisados</span></div></el-col>
            </el-row>

            <el-row :gutter="10" class="u-mb-10">
                <el-col :xs="12" :sm="5">
                    <el-select v-model="filtro.direcao" clearable size="small" placeholder="Direção" style="width: 100%;" @change="carregarLista">
                        <el-option value="entrada" label="Entrada"></el-option>
                        <el-option value="saida" label="Saída"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="12" :sm="5">
                    <el-select v-model="filtro.situacao" clearable size="small" placeholder="Situação" style="width: 100%;" @change="carregarLista">
                        <el-option value="processado" label="Processado"></el-option>
                        <el-option value="nao_identificado" label="Não identificado"></el-option>
                        <el-option value="duplicado" label="Duplicado"></el-option>
                        <el-option value="erro" label="Descartado"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="6">
                    <el-input v-model="filtro.aluno" size="small" placeholder="Aluno..." @keyup.native.enter="carregarLista"></el-input>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 90px;">Hora</th>
                            <th>Aluno</th>
                            <th style="width: 110px;" class="hidden-mobile">Turma</th>
                            <th style="width: 100px;" class="u-text-center">Direção</th>
                            <th style="width: 80px;" class="u-text-center">Score</th>
                            <th style="width: 140px;" class="hidden-mobile">Equipamento</th>
                            <th style="width: 130px;" class="u-text-center">Situação</th>
                            <th style="width: 120px;" class="u-text-center">Frequência</th>
                            <th style="width: 120px;" class="u-text-center">Responsável</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="e in items" :key="e.id">
                            <td>{{ hora(e.data_hora) }}</td>
                            <td>{{ e.aluno_nome || '—' }}</td>
                            <td class="hidden-mobile">{{ e.turma_nome || '—' }}</td>
                            <td class="u-text-center">
                                <el-tag size="mini" :type="e.direcao === 'entrada' ? 'success' : 'info'">{{ e.direcao }}</el-tag>
                            </td>
                            <td class="u-text-center">{{ e.score_confianca !== null ? e.score_confianca + '%' : '—' }}</td>
                            <td class="hidden-mobile">{{ e.equipamento }}</td>
                            <td class="u-text-center">
                                <el-tag size="mini" :type="corSituacao(e.situacao)">{{ rotuloSituacao(e.situacao) }}</el-tag>
                            </td>
                            <td class="u-text-center">
                                <el-tag v-if="e.frequencia_conflito_id" size="mini" type="danger">conflito</el-tag>
                                <el-tag v-else-if="e.gerou_frequencia" size="mini" type="success">gerada</el-tag>
                                <span v-else>—</span>
                            </td>
                            <!--
                                Item 129. "não enviado" não é falha em si: pode ser horário de
                                silêncio, notificação desligada ou responsável sem app. Por isso
                                o rótulo é neutro, e não um alerta vermelho.
                            -->
                            <td class="u-text-center">
                                <el-tag v-if="e.notificou_responsavel" size="mini" type="success">notificado</el-tag>
                                <span v-else class="sem-envio">não enviado</span>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="8" class="u-text-center">Nenhum evento para os filtros informados.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO J — itens 128 e 129: monitor de entradas e saídas. */
export default {
    data: () => ({
        statusList: true, instituicaoId: null, instituicoes: [], data: '',
        monitor: null, items: [], autoAtualizar: false, timer: null,
        filtro: { direcao: '', situacao: '', aluno: '' }
    }),
    mounted () {
        this.data = new Date().toISOString().substring(0, 10)

        const inst = this.$store.state.config.instituicao
        if (inst && inst.id) { this.instituicoes = [inst]; this.instituicaoId = inst.id }

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { if (Array.isArray(r.data) && r.data.length) this.instituicoes = r.data })
         .catch(() => {}).then(() => this.carregar())
    },
    /** O timer não pode sobreviver à saída da tela. */
    beforeDestroy () { this.pararAuto() },
    methods: {
        carregar () {
            this.monitor = null
            if (!this.instituicaoId || !this.data) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/evento-acesso/monitor/${this.instituicaoId}/${this.data}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.monitor = r.data
            }).catch(e => this.$store.commit('throwException', e))

            this.carregarLista()
        },
        carregarLista () {
            if (!this.instituicaoId) return
            this.statusList = false

            const payload = Object.assign({}, this.filtro, {
                instituicao_id: this.instituicaoId, data: this.data
            })

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/evento-acesso/getAllPaginate?page=1`,
                payload, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    this.statusList = true; return
                }
                this.items = r.data.data || []; this.statusList = true
            }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        },
        alternarAuto (v) { if (v) this.iniciarAuto(); else this.pararAuto() },
        iniciarAuto () {
            this.pararAuto()
            this.timer = setInterval(() => this.carregar(), 30000)
        },
        pararAuto () { if (this.timer) { clearInterval(this.timer); this.timer = null } },
        hora (d) { return d ? d.substring(11, 19) : '—' },
        rotuloSituacao (s) {
            return { processado: 'Processado', nao_identificado: 'Não identificado',
                duplicado: 'Duplicado', erro: 'Descartado' }[s] || s
        },
        corSituacao (s) {
            return { processado: 'success', nao_identificado: 'warning', duplicado: 'info', erro: 'danger' }[s] || 'info'
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
<style scoped>
.kpi { border: 1px solid #dcdfe6; border-radius: 4px; padding: 10px; text-align: center; margin-bottom: 8px; }
.kpi .n { display: block; font-size: 20px; font-weight: bold; }
.kpi .r { display: block; font-size: 11px; color: #606266; }
.kpi-entrada { border-left: 4px solid #67c23a; }
.kpi-saida { border-left: 4px solid #409eff; }
.kpi-ok { border-left: 4px solid #67c23a; }
.kpi-alerta { border-left: 4px solid #e6a23c; }
.sem-envio { color: #909399; font-size: 11px; }
.kpi-erro { border-left: 4px solid #f56c6c; }
</style>
